import { Component, OnInit, Input } from '@angular/core';
import { FormArray, FormGroup, FormBuilder } from '@angular/forms';
import { DropDownEntry } from 'src/app/services/API.service';
import { DropdownEntryForm } from '../../models/forms/dropdownentry-form';

@Component({
  selector: 'app-note',
  templateUrl: './note.component.html',
  styleUrls: ['./note.component.css']
})
export class NoteComponent implements OnInit {
  @Input() note: FormGroup;

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
  }

  addSelection() {
    var index = this.DropdownEntries.length;
    var entry: DropDownEntry = {
      __typename: "DropDownEntry",
      seq: index,
      value: null,
      text: null
    }
    var frmGrp = this.fb.group(new DropdownEntryForm(entry));

    this.DropdownEntries.push(frmGrp);

  }

  onMoveEntry(data: object) {
    var seq = this.DropdownEntries.controls[data['index']].get('seq').value;


    this.DropdownEntries.controls[data['index']].get('seq').setValue(seq + data['direction']);

    this.DropdownEntries.controls[data['index'] + data['direction']].get('seq').setValue(seq);

    this.sortDropdowns();

    this.note.markAsDirty();
  }

  onDelete(index: number) {
    this.DropdownEntries.removeAt(index);

    this.reIndex();
    
    this.DropdownEntries.markAsDirty();
  }

  sortDropdowns() {
    this.DropdownEntries.controls.sort((a,b) => a.get('seq').value - b.get('seq').value);
  }

  reIndex() {
    var index = 0;

    this.DropdownEntries.controls.forEach(n => {
      n.get('seq').setValue(index);
      index +=1;
    });
  }

  get DropdownEntries() {
    return this.note.get('DropDownEntries') as FormArray;
  }
}
